export enum SwapStatus {
  PENDING_DEPOSIT = 'Pending_deposit',
  CONFIRMING = 'Confirming',
  IN_QUEUE = 'In_Queue',
  PLANING_EXECUTION = 'Planing_execution',
  PROCESSING = 'Processing',
  COMPLETED = 'Completed',
}
